import type { Enterprise, EnterprisesState } from '../types/enterprises-types';

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api, { endpoints } from 'src/lib/axios';

const initialState: EnterprisesState = {
  enterprises: [],
  loading: false,
  error: null,
};

export const fetchEnterprises = createAsyncThunk(
  'enterprises/fetchEnterprises',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(endpoints.admin.enterprises);
      return response.data.enterprises as Enterprise[];
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Unknown error occurred');
    }
  }
);

export const deleteEnterprise = createAsyncThunk<string, string>(
  'enterprises/deleteEnterprise',
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`${endpoints.admin.enterprises}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Unknown error occurred');
    }
  }
);

const enterprisesSlice = createSlice({
  name: 'enterprises',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEnterprises.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEnterprises.fulfilled, (state, action) => {
        state.loading = false;
        state.enterprises = action.payload;
        state.error = null;
      })
      .addCase(fetchEnterprises.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(deleteEnterprise.fulfilled, (state, action) => {
        state.enterprises = state.enterprises.filter((ent) => ent.id !== action.payload);
        state.error = null;
      })
      .addCase(deleteEnterprise.rejected, (state, action) => {
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = enterprisesSlice.actions;
export default enterprisesSlice.reducer;
